import React from 'react';
import { Redirect } from 'react-router-dom';
import {
  SiteContainer,
  Flex,
  Wrapper,
  Aside,
  Main,
} from 'core/layout';
import { MetaList } from 'modules';
import { BreadcrumbsConnected } from 'elements';
import { PaginationNav } from 'elements/Pagination';
import { RawContent } from 'elements/util';
import { getDataFromACF } from 'utils/deepProps';
import {
  SaistitieRaksti,
  Apaksraksti,
  Galerija,
} from './components';
import {
  FlexGroup,
  StyledHeading,
  StyledContent,
  SubpageHeading,
} from './styled';

class Raksts extends React.PureComponent {
  render() {
    const { data, lang, path } = this.props;

    // NOTE: Ja data satur 'subpages' un masīvs nav tukšs,
    // kā arī tas nesatur lapu ar '_id' no data.current[0]._id –
    // veicam redirect uz pirmo apakšlapu no 'subpages'.

    let subpageIndex;
    let isSubpageOfParent = false;

    if (data.subpages && data.subpages.length > 0 && data.subpages[0]) {
      subpageIndex = data.subpages.findIndex(page => page && page._id === data.current[0]._id);
      if (subpageIndex === -1) {
        return (
          <Redirect to={
            data.subpages[0].path
          } />
        );
      } else {
        isSubpageOfParent = true;
      }
    }

    // - virs raksta ir saraksts ar uzskaitītām apakšlapām;
    // - zem raksta, 'Atpakaļ' un 'Tālāk' pogas uz
    //   nākamo vai iepriekšējo apakšlapu;

    // NOTE: acf var saturēt 'saistitie_raksti'. Piemērs "Bērna reģistrēšana skolā".
    // - izvada sarakstu ar virsrakstiem un saitēm raksta labajā pusē;
    let saistitieRaksti = getDataFromACF(data.current, 'saistitie_raksti');
    if (!saistitieRaksti) {
      if(data.parent && data.parent[0]){
        saistitieRaksti = getDataFromACF(data.parent, 'saistitie_raksti');
      }
    }

    let galerija;
    let galerijaAktiva = getDataFromACF(data.current, 'galerija_aktiva', false);
    if (!galerijaAktiva) {

      if(data.parent && Array.isArray(data.parent) && data.parent.length > 0){
        galerijaAktiva = getDataFromACF(data.parent, 'galerija_aktiva', false);
      }

      galerija = data.parent && Array.isArray(data.parent) && data.parent.length > 0 && data.parent[0].galerija;
    } else {
      galerija = data.current && Array.isArray(data.current) && data.current.length > 0 && data.current[0].galerija;
    }

    const currentPage = data.current && Array.isArray(data.current) ? data.current[0] : null;
    if (!currentPage) {
      return null;
    }

    const prevPage = (subpageIndex > 0) && data.subpages[subpageIndex - 1];
    const nextPage = (subpageIndex < data.subpages.length - 1) && data.subpages[subpageIndex + 1];

    return (
      <SiteContainer>

        <BreadcrumbsConnected
          lang={this.props.lang}
          path={this.props.path}
        />

        <Wrapper>
          <FlexGroup>

            <Main>
              <StyledHeading>
                {isSubpageOfParent ? data.parent[0].title : currentPage.title}
              </StyledHeading>

              {
                isSubpageOfParent && (
                  <Apaksraksti
                    currentPath={currentPage.path}
                    subpages={data.subpages}
                  />
                )
              }

              <StyledContent>
                {
                  isSubpageOfParent && (
                    <SubpageHeading level={2}>
                      {`${subpageIndex + 1}. ${currentPage.title}`}
                    </SubpageHeading>
                  )
                }
                <RawContent content={currentPage.content} />
              </StyledContent>

              {
                !!galerijaAktiva && Array.isArray(galerija) && galerija.length > 0 && (
                  <Galerija images={galerija} teksti={data.teksti} insideContent />
                )
              }

              <MetaList
                postType='default'
                dateCreated={currentPage.date_created}
                dateModified={currentPage.date_modified}
                teksti={data.teksti}
                lang={lang}
                acf={currentPage.acf}
              />

              {
                isSubpageOfParent && (
                  <PaginationNav
                    prev={prevPage && {
                      path: prevPage.path,
                      label: prevPage.title,
                    }}
                    next={nextPage && {
                      path: nextPage.path,
                      label: nextPage.title,
                    }}
                    teksti={data.teksti}
                  />
                )
              }
            </Main>

            <Aside>
              <SaistitieRaksti
                lang={lang}
                saistitieRaksti={saistitieRaksti}
              />
            </Aside>

          </FlexGroup>
        </Wrapper>

      </SiteContainer>
    )
  }
}

export default Raksts;



// WEBPACK FOOTER //
// ./src/pages/Raksts/Raksts.jsx